import React, { Component } from 'react';
import Success from '../contact/success';
import { Route } from 'react-router-dom';
import './joinlist.css';

class JoinList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			joinList : [],
			joinOpacity: 0,
			joinVisible: false            
		};
  }
	
	componentDidMount() {
		this.getJoin();
  }


	
	  // Retrieves the list of items from the Express app
  getJoin = () => {
		fetch('/api/join')
		.then(res => res.json())
		.then(joinList => this.setState({ joinList }));
  }

  joinScroll(e){
		var scrollY = 0;

		(!this.state.joinVisible)?(
			scrollY = e.target.scrollTop,
			scrollY < 800 ? (
				this.setState({joinOpacity: (scrollY/800)})
			):(   
					this.setState({joinOpacity:1}),
					this.setState({joinVisible: true})
			)
		):(
			scrollY < 800 ? (
				this.setState({joinVisible: false})
			):('')
		)
  }


	render() {
		const { joinList } = this.state;
		const opacity = this.state.joinOpacity;
		
		return (
			<React.Fragment>
				{joinList.length ? (
					<Route exact path='/join-us/success' render={()=><Success successMessage={joinList[0].joinNote}/>} />
				):(' ')}
				<div className="joinBG bgWhite fullWidth fullHeight" style={{"opacity": opacity}}></div>
					
				{joinList.length ? (
				  <div className="joinContent joinContainer fullWidth fullHeight blkT" style={{"opacity": this.state.joinOpacity+.001}} onScroll={this.joinScroll.bind(this)}>
						
						{joinList.map((item, i) => {
							return(
								<div className="joinUsHold fullWidth relative" key={i}>
									
									<div className="joinIntroText bT tfStage marginBotLarge" dangerouslySetInnerHTML={{ __html : item.joinIntro }}></div>
									<div className="joinFormHolder">
										<form className="joinForm tfStage relative" action="/join-us/send" id="join-form" method="post">
											<div className="blkACheckGrid fullWidth marginBotMed formItem " key={i+5}>
												<div className="blkHold clearBoth">
													<div className="checkHold floatLeft">
														<label className="blkBox"><input name="black" type="checkbox"></input>
														<span className="checkmark"></span></label>
													</div>
													<div className="floatLeft blkIntro" dangerouslySetInnerHTML={{ __html : item.joinBACheck }}></div>
												</div>
											</div>
											<input className="formItem resourceAuthor required" name="email" type="email" placeholder="EMAIL" required></input>
											<input className="formItem resourceAuthor required" name="firstName" type="text" placeholder="FIRST NAME" required></input>
											<input className="formItem resourceAuthor required" name="lastName" type="text" placeholder="LAST NAME" required></input>
											<input className="formItem resourceAuthor required" type="text" name="memberLocation" placeholder="LOCATION" required></input>
											<input className="formItem resourceAuthor marginBotMed" name="org" type="text" placeholder="ORGANIZATION/AFFILIATION"></input>
										   
											<div className="joinQuest marginTopMed marginBotTiny"  dangerouslySetInnerHTML={{ __html : item.joinQ1 }}></div>
											<input className="formItem resourceAuthor" type="text" name="quest1" placeholder="IF YES PLEASE SPECIFY" key={i+1}></input>

											<div className="joinQuest marginTopMed marginBotTiny" dangerouslySetInnerHTML={{ __html : item.joinQ2 }}></div>
											<input className="formItem resourceAuthor" type="text" name="quest2" placeholder="IF YES PLEASE SPECIFY"key={i+2}></input>

											<div className="joinQuest marginTopMed marginBotTiny" dangerouslySetInnerHTML={{ __html : item.joinQ3 }}></div>
											<input className="formItem resourceAuthor" type="text" name="quest3" placeholder="IF YES PLEASE SPECIFY" key={i+3}></input>

											<div className="joinQuest marginTopMed marginBotTiny" dangerouslySetInnerHTML={{ __html : item.joinQ4 }}></div>
											<input className="formItem resourceAuthor" type="text"  name="quest4" placeholder="IF YES PLEASE SPECIFY" key={i+4}></input>

											<p className="joinQuest marginTopMed marginBotTiny relative"> Interested in: 
											<span className="inputNote upperT boldT titleFont">Select all that apply</span>
											</p>
											
											<div className="formItem joinFormList" key={i+6}>
												<label className="container">Just looking to stay informed about this movement
													<input name="check1" type="checkbox"></input>
													<span className="checkmark"></span>
												</label>
												<label className="container">Joining our working group
													<input name="check2" type="checkbox"></input>
													<span className="checkmark"></span>
												</label>
												<label className="container">Connecting your organization/project with BSA
													<input name="check3" type="checkbox"></input>
													<span className="checkmark"></span>
												</label>
												<label className="container">Starting a Dual Power Project in your community
													<input name="check4" type="checkbox"></input>
													<span className="checkmark"></span>
												</label>
												<label className="container">Joining a Dual Power Project near you
													<input name="check5" type="checkbox"></input>
													<span className="checkmark"></span>
												</label>
											</div>
											<div className="joinQuest marginTopMed marginBotTiny" dangerouslySetInnerHTML={{ __html : item.joinQ5 }}></div>
											<textarea className="formItem resourceAuthor textArea"  name="quest5" type="text" placeholder="IF YES PLEASE SPECIFY"></textarea>
											<input className="buttonCTA formButton upperT boldT" type="submit" value='SUBMIT'></input>
										</form>
									</div>
								</div>
							)
						})}
					</div>
				):(
					<div className="fullWidth fullHeight redT blinkFast loader">
						<div className="centeredContent">•</div>
					</div>
				)}
			</React.Fragment>
		)
	}
}
  
export default JoinList;



// WEBPACK FOOTER //
// ./src/components/join/joinlist.js